import React from 'react';
import { LEVELS, LEVEL_HINTS } from '../constants/profileOptions';

export default function ProfileLevelPicker({ value, onChange }) {
  const hint = LEVEL_HINTS[value] || LEVEL_HINTS.intermediario;

  return (
    <div>
      <label className="section-label mb-2 block">Nível</label>
      <div className="grid grid-cols-2 gap-2 sm:grid-cols-3 lg:grid-cols-5">
        {LEVELS.map((l) => {
          const active = value === l.value;
          return (
            <button
              key={l.value}
              type="button"
              onClick={() => onChange?.(l.value)}
              className={`flex flex-col items-start rounded-lg border px-3 py-2 text-left transition-colors ${
                active
                  ? 'border-iron-accent bg-iron-accent text-black font-medium'
                  : 'border-iron-border text-iron-muted hover:border-iron-accent hover:text-iron-accent'
              }`}
            >
              <span className="font-mono text-xs">{l.label}</span>
              {l.sublabel ? (
                <span className={`mt-0.5 font-mono text-[9px] ${active ? 'text-black/70' : 'opacity-65'}`}>
                  {l.sublabel}
                </span>
              ) : null}
            </button>
          );
        })}
      </div>
      <p className="mt-2 rounded-lg border border-iron-accent/25 bg-iron-accent/5 px-3 py-2 text-xs text-iron-muted-strong">
        <strong className="text-iron-accent">A IA assume:</strong> {hint}
      </p>
    </div>
  );
}
